<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['Multilingual.columns.key']">
              <j-input :placeholder="language['basedata.pleaseEnter']+' '+language['Multilingual.columns.key']" v-model="queryParam.langKey"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="value">
              <j-input :placeholder="language['basedata.pleaseEnter']+' value'" v-model="queryParam.langTrans"></j-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="addRow" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <template v-for="(col, index) in columns" v-if="col.scopedSlots" :slot="col.dataIndex" slot-scope="text, record, index">
          <div :key="index">
            <a-input
              :disabled="!record.newRow && readonlyArr.includes(col.dataIndex)"
              :placeholder="language['basedata.pleaseEnter']"
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record.key, col.dataIndex)"
            />
            <template v-else>{{ text }}</template>
          </div>
        </template>
        <template slot="action" slot-scope="text, record, index">
          <div class="editable-row-operations">
          <span v-if="record.editable">
            <a @click="() => save(record)">{{language['common.save']}}</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="language['message.giveUpEditing']" @confirm="() => cancel(record.key)">
              <a>{{language['common.cancel']}}</a>
            </a-popconfirm>
          </span>
            <span v-else>
            <a class="edit" @click="() => edit(record.key)">{{language['common.edit']}}</a>
            <a-divider type="vertical" />
            <a class="delete" @click="() => del(record)">{{language['common.delete']}}</a>
          </span>
          </div>
        </template>

      </a-table>
    </div>

    <tSysLanguage-modal ref="modalForm" @ok="modalFormOk"></tSysLanguage-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TSysLanguageModal from './modules/TSysLanguageModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import { httpAction,deleteAction } from '@/api/manage'
  import JInput from '@/components/jeecg/JInput.vue';
  import {getAction} from "../../api/manage";

  export default {
    name: "TSysLanguageList",
    mixins:[JeecgListMixin],
    components: {
      JInput,
      JDictSelectTag,
      TSysLanguageModal
    },
    data () {
      return {
        // 表头
        data:{} ,
        readonlyArr: ['langKey'],
        url: {
          list: "/sys/tSysLanguage/list",
          delete: "/sys/tSysLanguage/delete",
          save: "/sys/tSysLanguage/addnew",
        },
        dictOptions:{},
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        columns:[
              {
                title: '#',
                dataIndex: '',
                key:'rowIndex',
                width:30,
                align:"center",
                customRender:function (t,r,index) {
                  return parseInt(index)+1;
                }
              },
              {
                title:this.$store.getters.language['Multilingual.columns.key'],
                align:"center",
                width:180,
                dataIndex: 'langKey',
                scopedSlots: { customRender: 'langKey' }
              },
              /*{
                title:this.$store.getters.language['Multilingual.columns.SimplifiedChinese'],
                align:"center",
                width:180,
                dataIndex: 'zh_CN',
                scopedSlots: { customRender: 'zh_CN' }
              },
              {
                title:this.$store.getters.language['Multilingual.columns.traditionalChinese'],
                align:"center",
                width:180,
                dataIndex: 'zh_TW',
                scopedSlots: { customRender: 'zh_TW' }
              },
              {
                title:this.$store.getters.language['Multilingual.columns.English'],
                align:"center",
                width:150,
                dataIndex: 'en_US',
                scopedSlots: { customRender: 'en_US' }
              },*/
              {
                title: this.$store.getters.language['common.action'],
                dataIndex: 'action',
                width:100,
                align:"center",
                scopedSlots: { customRender: 'action' }
              }
            ],
        languageTemplate:[],//this.$store.getters.languagelist


      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      /*columns(){
        if(this.language){
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:30,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['Multilingual.columns.key'],
              align:"center",
              width:180,
              dataIndex: 'langKey',
              scopedSlots: { customRender: 'langKey' }
            },
            {
              title:this.language['Multilingual.columns.SimplifiedChinese'],
              align:"center",
              width:180,
              dataIndex: 'zh_CN',
              scopedSlots: { customRender: 'zh_CN' }
            },
            {
              title:this.language['Multilingual.columns.traditionalChinese'],
              align:"center",
              width:180,
              dataIndex: 'zh_TW',
              scopedSlots: { customRender: 'zh_TW' }
            },
            {
              title:this.language['Multilingual.columns.English'],
              align:"center",
              width:150,
              dataIndex: 'en_US',
              scopedSlots: { customRender: 'en_US' }
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              width:100,
              align:"center",
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      }*/
    },
    created() {
      getAction("/sys/dictItem/languageTemplate",{dictCode:'system_language_template'}).then(res=>{
        if(res.success){
          this.languageTemplate = res.result;
          this.columns=[
                {
                  title: '#',
                  dataIndex: '',
                  key:'rowIndex',
                  width:30,
                  align:"center",
                  fixed: 'left',
                  customRender:function (t,r,index) {
                    return parseInt(index)+1;
                  }
                },
                {
                  title:this.$store.getters.language['Multilingual.columns.key'],
                  align:"center",
                  width:180,
                  fixed: 'left',
                  dataIndex: 'langKey',
                  scopedSlots: { customRender: 'langKey' }
                }
            ]
          res.result.forEach(item=>{
            let map = {
                title:this.language[item.langKey],
                align:"center",
                width:180,
                dataIndex: item.value,
                scopedSlots: { customRender: item.value }
            }
            this.columns.push(map);
          });
          this.columns.push(
            {
              title: this.$store.getters.language['common.action'],
              dataIndex: 'action',
              width:100,
              align:"center",
              fixed: 'right',
              scopedSlots: { customRender: 'action' }
            }
          );
        }
      })
    },
    mounted(){
    },
    updated(){
    },
    methods: {
      handleChange (value, key, column) {
        const newData = [...this.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.dataSource = newData;
        }
      },
      edit (rowKey) {
        const newData = [...this.dataSource];
        const target = newData.filter(item => rowKey === item.key)[0];
        // 根据rowKey判断该行数据是否存在
        if (target) {
          target.editable = true;   // 修改target可以直接影响到newData
          this.dataSource = newData;
        }
      },
      // eslint-disable-next-line
      del (row) {
        var that = this;
        this.$confirm({
          title: that.language['tip.titleCaveat'],
          content: that.language['tip.promptMessageDelete'],
          okText: that.language['common.delete'],
          cancelText: that.language['common.cancel'],
          onOk() {
            console.log('OK');
            // 在这里调用删除接口
            deleteAction("/sys/tSysLanguage/delete", {langKey:row.langKey}).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData();
              } else {
                that.$message.warning(res.message);
              }
            });
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      },
      save (row) {
        /*if(row.langKey.trim() == '' || row.zh_CN.trim() == ''
            || row.en_US.trim() == '' || row.zh_TW.trim() === ''){
          this.$message.warning(this.language['sys.i18n.dataIncomplete']);
          return
        }*/
        for(var i=0;i<this.languageTemplate.length;i++){
          let item = this.languageTemplate[i];
          let value = item.value;
          if((!row[value])||row[value].trim() == ''){
            this.$message.warning(this.language['sys.i18n.dataIncomplete']);
            return
          }
        }
        if(!this.url.save){
          this.$message.error("url.save!")
          return
        }
        var that = this;
        //let formData = Object.assign(this.model, values);
        httpAction(that.url.save, row,'post').then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            const newData = [...this.dataSource];
            const target = newData.filter(item => row.key === item.key)[0];
            if (target) {
              delete target.editable;
              this.dataSource = newData;
              this.cacheData = newData.map(item => ({...item}));
            }
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });

      },
      cancel (rowKey) {
        console.log(rowKey);
        const newData = [...this.dataSource];
        const target = newData.filter(item => rowKey === item.key)[0];
        if (target) {
          if(rowKey==="newRow"){
            delete target.editable;
            const cacheData = [...this.dataSource].filter((v, i)=>{
              return rowKey !== v.key;
            });
            this.dataSource = [...this.dataSource].filter((v, i)=>{
              return rowKey !== v.key;
            });
          }else{
            // 将缓存数据中匹配到的数据对象覆盖合并当前被修改的行
            Object.assign(target, this.cacheData.filter(item => rowKey === item.key)[0]);
            delete target.editable;
            this.dataSource = newData;
          }
        }


      },
      // 添加一行
      addRow() {
        if (this.dataSource.some(item => item.newRow === true)) return this.$message.info(this.language['common.addAfterEditing']);

        // 新增时取消表格选中的key
        this.selectedRowKeys = []
        let map = {
          key: 'newRow',  // newRow 表示该行是新增的，提交成功后 key替换为数据库ID
          newRow: true,   //用来限制只能新增一行
          id:"0",
          langKey: '',
          editable: true
        }
        this.languageTemplate.forEach(item=>{
           let value = item.value;
           map[value] = ''
        })
        this.dataSource.unshift(map)
        this.cacheData.unshift(map)
        /*this.dataSource.unshift({
          key: 'newRow',  // newRow 表示该行是新增的，提交成功后 key替换为数据库ID
          newRow: true,   //用来限制只能新增一行
          id:"0",
          langKey: '',
          cnLangCode:'zh_CN',
          enLangCode:'en_US',
          twLangCode:'zh_TW',
          cnLangTrans: '',
          twLangTrans: '',
          enLangTrans: '',
          editable: true
        })
        this.cacheData.unshift({
          key: 'newRow',
          newRow: true,
          id:"0",
          langKey: '',
          cnLangTrans: '',
          twLangTrans: '',
          enLangTrans: '',
          editable: false
        })*/
        console.log(this.dataSource)
      },

      onChange (row) {
        this.selectedRowKeys = row.selectedRowKeys
        this.selectedRows = row.selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },

      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>